import Vue, { CreateElement } from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import associatiRoute from '@/views/associati/router/associato-router';
import attoriRoute from '@/views/attori/router/attori-router';
import calendarioServiziRoute from '@/views/calendario-servizi/router/calendarioservizi-router';
import callcenterRoute from '@/views/callcenter/router/callcenter-router';
import statCallcenterRoute from '@/views/stat-callcenter/router/stat-callcenter-router';
import campagneRoute from '@/views/campagne/router/campagne-router';
import cassaRoute from '@/views/cassa/router/cassa-router';
import contattiRoute from '@/views/contatti/router/contatti-router';
import contiRoute from '@/views/conti/router/conti-router';
import dottoriRoute from '@/views/dottori/router/dottori-router';
import fattoriniRoute from '@/views/fattorini/router/fattorini-router';
import headquartersRoute from '@/views/headquarters/router/headquarters-router';
import listeRoute from '@/views/liste/router/liste-router';
import operatoriRoute from '@/views/operatori/router/operatori-router';
import pazientiRoute from '@/views/pazienti/router/paziente-router';
import riscossioniRoute from '@/views/riscossioni/router/riscossioni-router';
import rolefeaturesRoute from '@/views/rolefeatures/router/rolefeatures-router';
import serviziperiodiciRoute from '@/views/servizi-periodici/router/serviziperiodici-router';
import serviziRoute from '@/views/servizi/router/servizi-router';
import tipologieinterventoRoute from '@/views/tipologieintervento/router/tipologieintervento-router';
import tipologieservizioRoute from '@/views/tipologieservizio/router/tipologieservizio-router';
import utentiRoute from '@/views/utenti/router/utenti-router';
import veicoliRoute from '@/views/veicoli/router/veicoli-router';
import volontariRoute from '@/views/volontari/router/volontari-router';
import luoghiRoute from '@/views/luoghi/router/luoghi-router';
import sedeRoute from '@/views/sede/router/sede-router';

import { authGuard } from './auth-guard';

const RouterView = {
	render: (h: CreateElement) => h('router-view')
};

const routes: Array<RouteConfig> = [
	{
		path: '/',
		component: () => import('@/views/Main.vue'),
		meta: { auth: true },
		beforeEnter: authGuard,
		children: [
			{
				path: '',
				component: () => import('@/views/home/Home.vue'),
			},
			{
				path: '/utenti',
				component: RouterView,
				children: utentiRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'utenti',
					acl: 'section.utenti'
				}
			},
			{
				path: '/ruoli',
				component: RouterView,
				children: rolefeaturesRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'ruoli',
					acl: 'section.ruoli'
				}
			},
			{
				path: '/liste',
				component: RouterView,
				children: listeRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'liste',
					acl: 'section.liste'
				}
			},
			{
				path: '/sedi',
				component: RouterView,
				children: headquartersRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'sedi',
					acl: 'section.headquarters'
				}
			},
			{
				path: '/tipologieservizio',
				component: RouterView,
				children: tipologieservizioRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'tipologieservizio',
					acl: 'section.tipologieservizio'
				}
			},
			{
				path: '/tipologieintervento',
				component: RouterView,
				children: tipologieinterventoRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'tipologieintervento',
					acl: 'section.tipologieintervento'
				}
			},
			{
				path: '/veicoli',
				component: RouterView,
				children: veicoliRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'vehicles',
					acl: 'section.veicoli'
				}
			},
			{
				path: '/contatti',
				component: RouterView,
				children: contattiRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'contatti',
					acl: 'section.contatti'
				}
			},
			{
				path: '/campagne',
				component: RouterView,
				children: campagneRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'campagne',
					acl: 'section.campagne'
				}
			},
			{
				path: '/callcenter',
				component: RouterView,
				children: callcenterRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'callcenter',
					acl: 'section.callcenter'
				}
			},
			{
				path: '/stat-callcenter',
				component: RouterView,
				children: statCallcenterRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'stat-callcenter',
					acl: 'section.stat-callcenter'
				}
			},
			{
				path: '/operatori',
				component: RouterView,
				children: operatoriRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'operatori',
					acl: 'section.operatori'
				}
			},
			{
				path: '/fattorini',
				component: RouterView,
				children: fattoriniRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'fattorini',
					acl: 'section.fattorini'
				}
			},
			{
				path: '/riscossioni',
				component: RouterView,
				children: riscossioniRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'offers',
					acl: 'section.riscossioni'
				}
			},
			{
				path: '/attori',
				component: RouterView,
				children: attoriRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'actors',
					acl: 'section.attori'
				}
			},
			{
				path: '/servizi',
				component: RouterView,
				children: serviziRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'servizi',
					acl: 'section.servizi'
				}
			},
			{
				path: '/servizi-periodici',
				component: RouterView,
				children: serviziperiodiciRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'servizi-periodici',
					acl: 'section.serviziperiodici'
				}
			},
			{
				path: '/volunteers',
				component: RouterView,
				children: volontariRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'volunteers',
					acl: 'section.volontari'
				}
			},
			{
				path: '/associates',
				component: RouterView,
				children: associatiRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'associates',
					acl: 'section.associati'
				}
			},
			{
				path: '/patients',
				component: RouterView,
				children: pazientiRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'patients',
					acl: 'section.pazienti'
				}
			},
			{
				path: '/doctors',
				component: RouterView,
				children: dottoriRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'doctors',
					acl: 'section.dottori'
				}
			},
			{
				path: '/calendario-servizi',
				component: RouterView,
				children: calendarioServiziRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'services-calendar',
					acl: 'section.calendarioservizi'
				}
			},
			{
				path: '/conti',
				component: RouterView,
				children: contiRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'conti',
					acl: 'section.conti'
				}
			},
			{
				path: '/cassa',
				component: RouterView,
				children: cassaRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'cassa',
					acl: 'section.cassa'
				}
			},
			{
				path: '/luoghi',
				component: RouterView,
				children: luoghiRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'luoghi',
					acl: 'section.luoghi'
				}
			},
			{
				path: '/sede',
				component: RouterView,
				children: sedeRoute,
				beforeEnter: authGuard,
				meta: {
					title: 'sede',
					acl: 'section.sede'
				}
			}
		]
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/@core/components/auth/Login.vue')
	},
	{
		path: '/reset-password',
		name: 'Reset Password',
		component: () => import('@/@core/components/auth/ResetPassword.vue')
	},
	{
		path: '/404',
		name: '404',
		component: () => import('@/views/404.vue')
	}
];

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior: () => {
		return { x: 0, y: 0 };
	}
});

export default router;
